import "./style.scss";
import Glide from "@glidejs/glide";

import "@glidejs/glide/dist/css/glide.core.css";

import domReady from "@wordpress/dom-ready";

function Slider() {
  const qoutes = document.querySelectorAll(".slider.posts")[0];

  console.log(qoutes);

  var glide = new Glide(".slider.posts", {
    type: "slider",
    perView: 3,
    focusAt: "left",
    breakpoints: {
      800: {
        perView: 2,
      },
      480: {
        perView: 1,
      },
    },
  });

  glide.mount();
}

domReady(Slider);
